import { render, staticRenderFns } from "./EditActivityForm.vue?vue&type=template&id=052ab4d6&scoped=true"
import script from "./EditActivityForm.vue?vue&type=script&lang=ts"
export * from "./EditActivityForm.vue?vue&type=script&lang=ts"
import style0 from "./EditActivityForm.vue?vue&type=style&index=0&id=052ab4d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_babel-core@6.26.3_css-loader@6.11.0_webpack@5.111_qiwspig4cowntqqutyssg3tktu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ab4d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/.pnpm/vuetify-loader@1.7.3_vue-template-compiler@2.7.16_vuetify@2.7.2_vue@2.7.16__webpack@5.111.1_l_l56bdxpzvhkruchihen76mu6ae/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VCol,VFlex,VIcon,VLayout,VRow,VTextarea,VTooltip})
